// Escapes a value for safe interpolation into a double-quoted CSS attribute
// selector, e.g. `[data-cy="${escapeAttributeValue(name)}"]`. Without this,
// a `"` in user-supplied text (category/component names are free-form)
// terminates the attribute value early and throws a SyntaxError from
// querySelector.
export const escapeAttributeValue = (value: string): string =>
	value.replace(/["\\]/g, '\\$&');
